.tooltipWrapper {
  pointer-events: none;
  position: fixed;
  z-index: 99999;
}

.tooltip {
  position: absolute !important;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
}

.tooltip::before, .tooltip::after {
  transition-property: opacity !important;
}

.tooltip.visible::before, .tooltip.visible::after {
  opacity: 1 !important;
}
